
  /* eslint-disable */
  require("wpmjs")
  const localShared = require("/codebuild/output/src3366094767/src/$_mfplugin_virtualLocalShared/index.js")
  const {getUsedShare} = require("/codebuild/output/src3366094767/src/$_mfplugin_virtualSetShared/index.js")
  function pkgFilter(pkg) {
    const [prefix, shareName] = pkg.split("mfshare:") || []
    if (shareName) {
      const {
        version,
        shareScope,
      } = getUsedShare(shareName)
      return `mfshare:${shareScope}:${shareName}:${version}`
    }
    return pkg
  }
  if (!window["__mfplugin__phonex_admin"]) {
    window["__mfplugin__phonex_admin"] = {
      initSharedPromise: null,
      chunkMap: {},
      get(pkg = "") {
        return window.wpmjs.get(pkgFilter(pkg))
      },
      import(pkg = "") {
        return window.wpmjs.import(pkgFilter(pkg))
      },
      async wait(pkgs) {
        await this.initSharedPromise
        pkgs = pkgs || []
        return Promise.all([
          window.wpmjs.wait(pkgs.map(pkgFilter))
        ])
      }
    }
  }
  const {initShared} = require("/codebuild/output/src3366094767/src/$_mfplugin_virtualSetShared/index.js")
  const initConfig = {"idUrlMap":{"phonex_ai_extensions":"https://d2w76aegyjxnvf.cloudfront.net/remoteEntry.js"},"idDefineMap":{"phonex_ai_extensions":{"remoteType":"mf","name":"phonex_ai_extensions"}}}
  window.wpmjs.setConfig(initConfig)
  window["__mfplugin__initSharedPromise__phonex_admin"] = initShared()
  